import React from 'react'
import Hero from '../Hero/Hero'
import MCat from '../Category/MCat'
import NewArrivals from '../Arrivals/NewArrivals'

function Home() {
    return (
        <div>
            <Hero/>
            <MCat/>
            <NewArrivals/>
        </div>
    )
}

export default Home
